import React from 'react'
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import Countdown from '../utils/Countdown';
import { DELAY } from '../../../Constants';

const styles = (theme: Theme) => ({
  containerRoot: {
    margin: '20px auto',
  }
});

const circleProps = {
  bgcolor: '#4285f41c',
  borderColor: 'primary.main',
  mx: 'auto',
  border: 2,
  style: { width: '7rem', height: '7rem' },
};

interface Props {
  handlePlayRecord: () => void;
  handleStopRecord: () => void;
  status: string;
  onClose: () => void
}

interface State {
  isOpen: boolean;
}

type PropsWithStyles = Props & WithStyles<'containerRoot'>;

class CountdownDialog extends React.Component<PropsWithStyles, State> {

  private timeoutCountdown: any = null;

  constructor(props: PropsWithStyles) {
    super(props);
    this.state = {
      isOpen: false
    };
  }  

  componentWillUnmount(): void {
    clearTimeout(this.timeoutCountdown)
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.status !== this.props.status) {
      if(this.props.status === 'recording') {
        this.delayRecord()
      }
    }
  }   

  handleClose = () => {
    clearTimeout(this.timeoutCountdown)
    this.props.onClose()
    this.props.handleStopRecord();
    this.setState({ isOpen: false });
  }

  delayRecord = () => {
    clearTimeout(this.timeoutCountdown)    
    this.setState({ isOpen: true });
    this.timeoutCountdown = setTimeout(() => {
      this.setState({ isOpen: false });
      this.props.handlePlayRecord()
    }, DELAY);
  }

  render() {
    const { classes } = this.props;
    const { isOpen } = this.state

    return(
      <Dialog
        fullScreen
        open={isOpen}
        onClose={this.handleClose}
        aria-labelledby="dialog-countdown"
      >
      <Container maxWidth="sm" classes={{root: classes.containerRoot}}>      
        <Box>     
          <Box my={2} textAlign="center">
            <DialogTitle>Recording in...</DialogTitle>
              <DialogContent>
                <Box borderRadius="50%" {...circleProps}>
                  <Countdown
                    startTime={DELAY/1000} 
                  />
                </Box>
                <Box my={4}>
                  <Button
                    size="large"
                    onClick={this.handleClose}
                    color="primary"
                  >
                    Cancel
                  </Button>
                </Box>
              </DialogContent>
          </Box>
        </Box>
      </Container>        
      </Dialog>
    );

  }

  }

export default withStyles(styles)(CountdownDialog);  